import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import HeroSlider from "./components/HeroSlider";
import IntroSection from "./components/IntroSection";
import ServiceCards from "@/components/feature/ServiceCards";
import AboutSection from "./components/AboutSection";
import ContactCTA from "./components/ContactCTA";

export default function HomePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="NetBasis International - linking people & business"
        description="Erfolgreicher Markteintritt und B2B-Wachstum für ausländische ITK-Hersteller in Deutschland, Österreich und der Schweiz."
        ogUrl="https://net-basis.net/de"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <HeroSlider
          texts={{
            slide1_title: "Neue Märkte, neues Geschäft ... kein Risiko!",
            slide2_title: "Mit uns mitten ins Herz Europas!",
            slide3_title: "Deutschland (DACH) – Ihr Erfolg mit einem Partner vor Ort!",
            slide4_title: "Gemeinsam stark!",
            slide4_subtitle: "Business Development\nConsulting\nInterim Management\nTraining & Coaching",
            slide5_title: "Jetzt durchstarten!",
            prev_slide: "Vorherige Folie",
            next_slide: "Nächste Folie",
            slide_label: "Folie {{number}}",
            alts: [
              "Finger berührt einen digital vernetzten Globus für risikoarmen ITK-Markteintritt.",
              "Finger markiert Europa auf einer vernetzten Weltkarte für den ITK-Markteintritt.",
              "Blaue Deutschlandkarte mit Bundesländern symbolisiert lokale ITK-Partnerschaft beim Markteintritt.",
              "Geschäftsmann bedient digitale Oberfläche für ITK-Services beim DACH-Markteintritt.",
              "Finger aktiviert digitales Startsymbol für erfolgreichen ITK-Markteintritt in Europa.",
            ],
          }}
        />

        <IntroSection
          texts={{
            title: "NetBasis International - linking people & business",
            heading:
              "Ihr operativer Partner für Ihren erfolgreichen Markteintritt in der DACH-Region. Wir unterstützen und steuern Ihre Marktaktivitäten vor Ort – maßgeschneidert durch die Übernahme der gesamten lokalen Tätigkeit oder flexibel für einzelne Aufgabenbereiche.",
            paragraph1:
              "Der erfolgreiche Aufbau, die Steigerung und die Expansion von Geschäften in neuen Märkten müssen für ausländische Unternehmen vor allem eines sein: vielversprechend, schnell, effizient, kostengünstig und sicher. Langwierige Marktstudien, komplizierte Strategieentwicklungen mit unklaren Entscheidungsprozessen oder der fehlende direkte Zugang zum Zielmarkt sind hierbei der falsche Ansatz. Oft möchten Hersteller einen neuen Markt zudem ohne große Vorab-Investitionen betreten.",
            paragraph2:
              "Genau an diesem Punkt ist NetBasis International der richtige Partner an Ihrer Seite. Seit fast 20 Jahren begleiten und unterstützen wir ausländische Unternehmen aus der Telekommunikations- und IT-Branche erfolgreich in attraktiven, aber anspruchsvollen Märkten – mit klarem Fokus auf den deutschsprachigen Wirtschaftsraum (DACH-Region).",
            strong_name: "NetBasis International",
          }}
        />

        <ServiceCards
          namespace="home"
          titleKeys={[
            "services.service1_title",
            "services.service2_title",
            "services.service3_title",
            "services.service4_title",
          ]}
          descriptionKeys={[
            "services.service1_description",
            "services.service2_description",
            "services.service3_description",
            "services.service4_description",
          ]}
          readMoreKey="services.read_more"
          texts={{
            titles: [
              "Business Development",
              "Consulting",
              "Interim Management",
              "Training & Coaching",
            ],
            descriptions: [
              "Erfolg im DACH-Markt? Wir ebnen Ihnen den Weg! Mit uns öffnen sich Ihnen Türen. Wir packen an und setzen um!",
              "Wissen, wie's geht? Wir geben Ihnen Durchblick! Wir beraten mit Weitsicht. Wir schützen Ihr Projekt!",
              "Temporärer Bedarf? Wir decken ihn kompetent! Wir schließen die Lücke. Wir geben Ihnen Sicherheit!",
              "Neue Märkte im Blick? Wir machen Sie startklar! Wir trainieren die Praxis. Wir sichern Ihr Vorhaben!",
            ],
            readMore: "Mehr erfahren",
          }}
        />

        <AboutSection
          texts={{
            title: "NetBasis International - drive to excellence with excellent drivers !",
            paragraph1:
              "Als anerkannte Experten mit Sitz in Deutschland – dem bedeutendsten europäischen Markt – helfen wir von NetBasis International Ihnen, Eintrittsbarrieren abzubauen, strategische Optionen zu prüfen, realistische Vermarktungskonzepte zu entwickeln, geeignete Partner zu finden und potenzielle Kunden direkt anzusprechen. Zuverlässig und ergebnisorientiert bieten wir Ihnen eine breite Palette an Services: von der Markteintritts- und Entwicklungsplanung über Vertrieb, Marketing und Öffentlichkeitsarbeit bis hin zu technischem Support und Personalbeschaffung.",
            paragraph2:
              "Durch die Zusammenarbeit mit uns profitieren Sie von einer zentralen Anlaufstelle für Ihr gesamtes Projekt. Sie erhalten sofortigen Zugriff auf das notwendige Know-how und die operative Expertise, die für Ihren Markterfolg unabdingbar sind. Mit unserem pragmatischen Ansatz erarbeiten wir gemeinsam die spezifischen Bedingungen und Anforderungen Ihrer Zielländer.",
            paragraph3:
              "Dabei haben Sie die Wahl, wie Sie uns einsetzen: Wir können das gesamte Projekt übernehmen und erfüllen an Ihrer Stelle für eine festgelegte oder unbestimmte Zeit die tatsächliche Arbeit vor Ort. Alternativ unterstützen wir Sie gezielt bei einzelnen Aufgaben, begleiten Sie rein beratend als Consultants auf Ihrem eigenen Weg oder kooperieren mit Ihnen im Bereich Training und Coaching.",
            paragraph4:
              "Für welche Services Sie sich auch entscheiden: NetBasis International stimmt alle relevanten Mittel und Maßnahmen perfekt aufeinander ab, um Ihr Business effizient voranzubringen.",
            strong_name: "NetBasis International",
          }}
        />

        <ContactCTA
          texts={{
            title: "Nehmen Sie jetzt direkt Kontakt mit uns auf.",
            cta_button: "Kontaktformular",
            link_url: "/de/kontakt",
          }}
        />
      </main>

      <Footer />
    </div>
  );
}